import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { FloatLabel } from "primereact/floatlabel";

const Login = () => {
  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  /** 🔥 2. Gère le login */
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("../backend/admin/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      console.log("✅ API Response:", data);

      if (data.success) {
        // ✅ Stocke en localStorage pour la session


        navigate("/admin");
      } else {
        setError(data.error || "Invalid credentials");
      }
    } catch (error) {
      console.error("❌ Login error:", error);
      setError("Login failed");
    }
  };

  return (
    <div className="login-container">
      <div>
      <h3>Login</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className="field">
        <FloatLabel>
          <InputText value={username} onChange={(e) => setusername(e.target.value)} />
          <label>Username</label>
        </FloatLabel>
      </div>
      <div className="field">
        <FloatLabel>
          <Password value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} />
          <label>Password</label>
        </FloatLabel>
      </div>
      <div className="field">
        <Button label="Login" onClick={handleLogin} className="p-button-primary" />
      </div>
      </div>
    </div>
  );
};

export default Login;
